<script>
    import { auth } from './firebase';

    export let displayName;
    export let photoURL;
</script>
<style>
    h1 {
        margin: .8em 0 0 0;
        color: #fff;
        font-size: 8vw;
        line-height: .8;
        font-weight: 100;
    }
    h3 {
        margin: .5em 0;
        font-size: 15px;
        font-weight: 100;
        color: #fff;
    }
    section {
        padding: 1em  1em 2em 1em;
    }
    .user {
        display: grid;
        grid-auto-flow: column;
        grid-gap: 20px;
        align-items: center;
        flex-direction: column;
        justify-content: flex-start;
    }
    img {
        display: inline-block;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        border: 3px solid rgba(99, 46, 29, .5);
    }
    button {
        padding: 3px 15px 5px;
        font-size: 20px;
        background: rgba(99, 46, 29, .5);
        border-radius: 30px;
        font-weight: 100;
        color: #fd754a;
    }
</style>
<section>
    <div class="user">
        <img src={photoURL} width="100" alt={displayName} />
        <div>
            <h3>{displayName}</h3>
            <button on:click={() => auth.signOut()} class="button">Logout</button>
        </div>
    </div>
    <h1>Deine<br/>Einkaufsliste</h1>
</section>